import { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { fetchPages } from '../store';

const usePages = () => {
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.data.loading);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);

  useEffect(() => {
    dispatch(fetchPages());
  }, [dispatch]);

  return { loading, data, error };
};

export default usePages;
